<template>
  <el-drawer
    title="发布需求"
    v-model="visible"
    direction="rtl"
    :before-close="handleClose"
    class="demand-drawer"
    :destroy-on-close="true"
    :wrapperClosable="false"
    append-to-body
  >
    <div class="content-wrap">
      <el-form
        ref="DemandFormRef"
        :model="demandForm"
        label-width="136px"
        class="demand-form"
        :rules="rules"
      >
        <!-- <el-form-item
          label="需求分类："
          prop="demandType"
          v-if="currentEnterpriseConfig.showFormItem.includes('需求分类')"
        >
          <el-radio v-model="demandType" label="common" @change="demandTypeChange"
            >发布需求</el-radio
          >
          <el-radio v-model="demandType" label="specified" @change="demandTypeChange"
            >寻找指定资源</el-radio
          >
        </el-form-item> -->
        <el-form-item
          label="需求类型："
          prop="purposeType"
          v-if="currentEnterpriseConfig.showFormItem.includes('需求类型')"
        >
          <el-select
            v-model="demandForm.purposeType"
            class="form-item-style-01"
            @change="handleSelect"
          >
            <el-option label="找原料" value="MATERIAL"></el-option>
            <el-option label="找代工" value="OEM"></el-option>
            <el-option label="找成品" value="END_PROD"></el-option>
            <el-option label="找包材" value="PKG"></el-option>
            <el-option label="找其他资源" value="OTHER"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="`${currentEnterpriseConfig.title}：`"
          prop="title"
          v-if="currentEnterpriseConfig.showFormItem.includes(currentEnterpriseConfig.title)"
        >
          <el-autocomplete v-if="demandForm.purposeType === 'MATERIAL'" v-model="demandForm.title" :fetch-suggestions="querySearchMaterialName"
            :placeholder="currentEnterpriseConfig.titlePlaceholder" class="form-item-style-01" :maxlength="50" show-word-limit
            ></el-autocomplete>
          <el-input
            v-else
            v-model="demandForm.title"
            maxlength="30"
            show-word-limit
            :placeholder="currentEnterpriseConfig.titlePlaceholder"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="产品品类："
          prop="oemCategory"
          v-if="currentEnterpriseConfig.showFormItem.includes('产品品类')"
        >
          <el-input
            v-model="demandForm.oemCategory"
            maxlength="20"
            show-word-limit
            placeholder="请输入产品品类"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="包材类型："
          prop="pkgCategory"
          v-if="currentEnterpriseConfig.showFormItem.includes('包材类型')"
        >
          <el-select v-model="demandForm.pkgCategory" class="form-item-style-01" placeholder="请选择包材类型">
            <el-option
              v-for="(item, index) in pkgTypes"
              :key="index"
              :label="item.dictLabel"
              :value="item.dictLabel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="包材材质："
          prop="pkgMaterial"
          v-if="currentEnterpriseConfig.showFormItem.includes('包材材质')"
        >
          <el-select v-model="demandForm.pkgMaterial" class="form-item-style-01" placeholder="请选择包材材质">
            <el-option
              v-for="(item, index) in pkgMaterialOptions"
              :key="index"
              :label="item.dictLabel"
              :value="item.dictLabel"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="参考图片："
          prop="images"
          v-if="currentEnterpriseConfig.showFormItem.includes('参考图片')"
        >
          <AppUpload
            v-model:imageList="demandForm.images"
            :ossClient="client"
            :limit="10"
            :maxSize="5 * 1024 * 1024"
            uploadDesc="请上传1-10个JPG/PNG格式文件，单个大小不超过5M。"
            errorText="请上传1-10个JPG/PNG格式文件，单个大小不超过5M。"
            :imageStyle="{
              width: '112px',
              height: '112px',
            }"
            class="upload-wrap"
            :uploadImagePath="ossConfig?.uploadPathDict?.demand"
          />
        </el-form-item>
        <el-form-item
          label="功效："
          prop="materialPurpose"
          v-if="demandForm.purposeType === 'MATERIAL' && currentEnterpriseConfig.showFormItem.includes('功效')"
        >
          <el-input
            v-model="demandForm.materialPurpose"
            maxlength="30"
            show-word-limit
            placeholder="请填写原料功效（如：保湿 / 抗皱）"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="功效："
          prop="efficacy"
          v-if="demandForm.purposeType !== 'MATERIAL' && currentEnterpriseConfig.showFormItem.includes('功效')"
        >
          <el-input
            v-model="demandForm.efficacy"
            maxlength="30"
            show-word-limit
            placeholder="请输入产品功效（如：保湿 / 抗皱）"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="求购数量："
          prop="demandQuantity"
          v-if="currentEnterpriseConfig.showFormItem.includes('求购数量')"
        >
          <el-input
            v-model="demandForm.demandQuantity"
            maxlength="15"
            show-word-limit
            :placeholder="currentEnterpriseConfig.demandQuantityPlaceholder"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="目标厂家："
          prop="refers"
          v-if="currentEnterpriseConfig.showFormItem.includes('目标厂家')"
        >
          <el-input
            v-model="demandForm.refers"
            maxlength="50"
            show-word-limit
            :placeholder="currentEnterpriseConfig.refersPlaceholder"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="详细描述："
          prop="content"
          v-if="currentEnterpriseConfig.showFormItem.includes('详细描述')"
        >
          <el-input
            v-model="demandForm.content"
            maxlength="50"
            show-word-limit
            :placeholder="currentEnterpriseConfig.appearancePlaceholder"
            type="textarea"
            resize="none"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>

        <div class="my-info-wrap">
          我的信息<span class="my-info-tip">(建议填写全部联系方式，让供应商更方便联系您，至少需填写1项)</span>
        </div>
        <el-form-item
          label="企业名称："
          prop="enterpriseName"
          v-if="currentEnterpriseConfig.showFormItem.includes('企业名称')"
        >
          <div class="enterprise-name">{{ demandForm.enterpriseName || '-' }}</div>
        </el-form-item>
        <el-form-item
          label="联系人："
          prop="userName"
          v-if="currentEnterpriseConfig.showFormItem.includes('联系人')"
        >
          <el-input
            v-model="demandForm.userName"
            maxlength="10"
            show-word-limit
            placeholder="请输入联系人姓名"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机："
          prop="userPhone"
          v-if="currentEnterpriseConfig.showFormItem.includes('手机')"
        >
          <el-input
            v-model="demandForm.userPhone"
            maxlength="11"
            show-word-limit
            placeholder="请输入手机号"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱："
          prop="userEmail"
          v-if="currentEnterpriseConfig.showFormItem.includes('邮箱')"
        >
          <el-input
            v-model="demandForm.userEmail"
            maxlength="50"
            show-word-limit
            placeholder="请输入邮箱"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="微信："
          prop="userWx"
          v-if="currentEnterpriseConfig.showFormItem.includes('微信')"
        >
          <el-input
            v-model="demandForm.userWx"
            maxlength="20"
            show-word-limit
            placeholder="请输入微信"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <div class="tips">
          <div class="tips-label">温馨提示：</div>
          <div class="tips-content">
            <div>1、请确保您发布需求符合法律法规，待审核通过后将自动公开展示至[需求大厅]。</div>
            <div>2、除了在需求大厅企业主动给您发供货申请外，平台还会匹配供应商主动联系您。</div>
          </div>
        </div>
      </el-form>

      <!-- <el-form
        v-if="demandType === 'specified'"
        ref="SpecifiedFormRef"
        :model="specifiedForm"
        label-width="146px"
        class="specified-form"
        :rules="specifiedRules"
      >
        <el-form-item label="需求分类：" prop="demandType">
          <el-radio v-model="demandType" label="common" @change="demandTypeChange"
            >发布需求</el-radio
          >
          <el-radio v-model="demandType" label="specified" @change="demandTypeChange"
            >寻找指定资源</el-radio
          >
        </el-form-item>
        <el-form-item label="资源类型：" prop="enterpriseType">
          <el-select v-model="specifiedForm.enterpriseType" class="form-item-style-01">
            <el-option label="工厂" value="oem"></el-option>
            <el-option label="产品" value="product"></el-option>
            <el-option label="包材" value="pkg"></el-option>
            <el-option label="原料" value="material"></el-option>
            <el-option label="其他" value="other"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应链资源名称：" prop="refers">
          <el-input
            v-model="specifiedForm.refers"
            maxlength="50"
            show-word-limit
            placeholder="请输入"
            type="textarea"
            resize="none"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源描述：" prop="content">
          <el-input
            v-model="specifiedForm.content"
            maxlength="50"
            show-word-limit
            placeholder="请输入资源描述"
            type="textarea"
            resize="none"
            class="form-item-style-01"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" prop="phone">
          <div class="phone-wrap">
            <el-select v-model="specifiedForm.phoneType" class="phone-type form-item-style-01">
              <el-option label="中国大陆(+86)" value="中国大陆"></el-option>
              <el-option label="中国香港(+852)" value="中国香港"></el-option>
              <el-option label="中国澳门(+853)" value="中国澳门"></el-option>
              <el-option label="中国台湾(+886)" value="中国台湾"></el-option>
            </el-select>
            <el-input
              v-model="specifiedForm.userPhone"
              :maxlength="specifiedPhoneMaxLength"
              show-word-limit
              placeholder="请输入"
              class="phone-number"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="上传附件：" prop="images">
          <AppUpload
            :imageList.sync="specifiedForm.images"
            :ossClient="client"
            :limit="10"
            :uploadImagePath="ossConfig.directoryPath"
            uploadDesc="支持jpg/png格式，单张2MB以内；数量不超过10张"
            errorText="上传失败，文件应为不超过2MB的JPG、PNG格式。"
            :imageStyle="{
              width: '96px',
              height: '96px',
            }"
          />
        </el-form-item>
      </el-form> -->

      <div class="footer">
        <el-button class="cancle-btn" @click="handleClose">取消</el-button>
        <el-button type="primary" class="confirm-btn" @click="submitDemand">提交</el-button>
      </div>
    </div>

    <el-dialog v-model="successDialogVisible" title="系统提示" width="600px" :append-to-body="true" class="demand-success-dialog" @close="handleCloseDialog">
      <div class="success-dialog-content">
        <div class="success-wrap">
          <i class="icon-success"></i>
          需求提交成功
        </div>
        <div class="success-tips">
          <div class="tips-label">温馨提示：</div>
          <div class="tips-content">
            若想取消发布需求，请至  <span class="tips-text">[供应链库-我的-我的需求]</span> 进行取消。
          </div>
        </div>
        <div class="footer-wrap">
          <div class="footer-btn button-gradient" @click="handleCloseDialog">知道了</div>
        </div>
        
      </div>
    </el-dialog>
  </el-drawer>
</template>

<script setup lang="ts">
  import { computed, ref, watch } from 'vue'
  // import { ElDrawer, ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElAutocomplete, ElButton, ElDialog } from 'element-plus'
  import AppUpload from './AppUpload/AppUpload.vue'
  import {
    addDemand,
    getPkgProductTypes,
    getPkgProductMaterial,
    getMaterialByName,
    getInfo,
    updateInfo,
  } from '../../api/publish-demand'
  import { fetchOssConfig } from '@/api'
  import { message } from '@/utils/message'
  import { useWorkspaceStore } from '@/store'
  import OSS from 'ali-oss'

  // FormInstance type
  interface FormInstance {
    validate: (callback: (valid: boolean) => void) => void
    resetFields: () => void
    clearValidate: () => void
  }

  // Types
  interface DemandForm {
    purposeType: 'MATERIAL' | 'OEM' | 'END_PROD' | 'PKG' | 'OTHER'
    title: string
    images: Array<{ imgUrl: string }>
    materialPurpose: string
    efficacy: string
    demandQuantity: string
    refers: string
    content: string
    oemCategory: string
    pkgCategory: string
    pkgMaterial: string
    enterpriseName: string
    userName: string
    userPhone: string
    userEmail: string
    userWx: string
  }

  interface EnterpriseConfig {
    showFormItem: string[]
    title: string
    titlePlaceholder: string
    demandQuantityPlaceholder: string
    refersPlaceholder: string
    appearancePlaceholder: string
    submitFormKey: string[]
  }

  interface OssConfig {
    uploadPathDict: {
      demand: string
    }
    accessKeyId: string
    accessKeySecret: string
    securityToken: string
    bucket: string
    directoryPath?: string
  }

  interface DictItem {
    dictLabel: string
    dictValue: string
  }

  interface MaterialSuggestion {
    ingredientName: string
    value: string
    label: string
  }

  interface UserContactInfo {
    userName?: string
    userPhone?: string
    userEmail?: string
    userWx?: string
  }

  // Props & Emits
  interface Props {
    modelValue: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
  })

  const emit = defineEmits<{
    (e: 'closeDemandDrawer', value: boolean): void
    (e: 'success'): void
    (e: 'update:modelValue', value: boolean): void
  }>()

  // Store
  const workspaceStore = useWorkspaceStore()
  const currentWorkspace = computed(() => workspaceStore.currentWorkspace)
  const workspaceId = computed(
    () => workspaceStore.currentWorkspace.workspaceId as number
  )

  // OSS Configuration
  const client = ref<any>({})
  const ossConfig = ref<OssConfig>({} as OssConfig)

  const getOssConfigByKey = async (): Promise<void> => {
    try {
      const resp: any = await fetchOssConfig()
      ossConfig.value = resp
      initOSS()
    } catch (error) {
      console.log('getOssConfigByKey error', error)
    }
  }

  const initOSS = (): void => {
    client.value = new OSS({
      // yourRegion填写Bucket所在地域。以华东1（杭州）为例,Region填写为oss-cn-hangzhou。
      region: 'oss-cn-hangzhou',
      // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
      accessKeyId: ossConfig.value.accessKeyId,
      accessKeySecret: ossConfig.value.accessKeySecret,
      // 从STS服务获取的安全令牌（SecurityToken）。
      stsToken: ossConfig.value.securityToken,
      // 填写Bucket名称。
      bucket: ossConfig.value.bucket,
    })
  }

  // Material Name Search
  const querySearchMaterialName = async (
    queryString: string,
    cb: (suggestions: MaterialSuggestion[]) => void
  ): Promise<void> => {
    if (!queryString.trim()) {
      cb([])
      return
    }
    try {
      const resp: any = await getMaterialByName({ name: queryString })
      const list: MaterialSuggestion[] = resp.map((item: any) => {
        return {
          ...item,
          value: item.ingredientName,
          label: item.ingredientName,
        }
      })
      cb(list)
    } catch (error) {
      console.log(error)
      cb([])
    }
  }

  // Package Types
  const pkgTypes = ref<DictItem[]>([])
  const getPkgTypes = async (): Promise<void> => {
    try {
      const resp: any = await getPkgProductTypes()
      pkgTypes.value = resp.tkpc_pkg_category_type || []
    } catch (error) {
      console.log(error)
    }
  }

  const pkgMaterialOptions = ref<DictItem[]>([])
  const getPkgMaterialOptions = async (): Promise<void> => {
    try {
      const resp: any = await getPkgProductMaterial()
      pkgMaterialOptions.value = resp.tkpc_pkg_product_material || []
    } catch (error) {
      console.log(error)
    }
  }

  // Drawer Visibility Control
  const visible = computed({
    get: () => props.modelValue,
    set: (value: boolean) => emit('update:modelValue', value),
  })

  const getUserContactInfo = (): void => {
    getInfo().then((res: UserContactInfo) => {
      demandForm.value.userName = res.userName || ''
      demandForm.value.userPhone = res.userPhone || ''
      demandForm.value.userEmail = res.userEmail || ''
      demandForm.value.userWx = res.userWx || ''
    })
  }

  watch(
    () => props.modelValue,
    async (newVal: boolean) => {
      if (newVal) {

        getOssConfigByKey()
        getUserContactInfo()
        getPkgTypes()
        getPkgMaterialOptions()
      }
    },
    { immediate: true, deep: true }
  )

  // Form Data
  const demandForm = ref<DemandForm>({
    purposeType: 'MATERIAL',
    title: '',
    images: [],
    materialPurpose: '',
    efficacy: '',
    demandQuantity: '',
    refers: '',
    content: '',
    oemCategory: '',
    pkgCategory: '',
    pkgMaterial: '',
    enterpriseName: currentWorkspace.value.workspaceName,
    userName: '',
    userPhone: '',
    userEmail: '',
    userWx: '',
  })

  const initForm = (): void => {
    demandForm.value = {
      purposeType: 'MATERIAL',
      title: '',
      images: [],
      materialPurpose: '',
      efficacy: '',
      demandQuantity: '',
      refers: '',
      content: '',
      oemCategory: '',
      pkgCategory: '',
      pkgMaterial: '',
      enterpriseName: currentWorkspace.value.workspaceName,
      userName: '',
      userPhone: '',
      userEmail: '',
      userWx: '',
    }
  }

  const DemandFormRef = ref<FormInstance | null>(null)

  const handleClose = (): void => {
    DemandFormRef.value?.resetFields()
    initForm()
    emit('closeDemandDrawer', false)
    emit('update:modelValue', false)
  }

  // Form Validation Rules
  const rules = ref({
    purposeType: [{ required: true, message: '请选择需求类型', trigger: 'change' }],
    title: [
      {
        required: true,
        trigger: 'blur',
        validator: (rule: any, value: any, callback: any) => {
          if (!demandForm.value.title.trim()) {
            callback(`"${currentEnterpriseConfig.value.title}"不能为空`)
          }
          callback()
        },
      },
    ],
    userName: [
      {
        required: true,
        trigger: 'blur',
        validator: (rule: any, value: any, callback: any) => {
          if (!demandForm.value.userName.trim()) {
            callback('请输入联系人姓名')
          }
          callback()
        },
      },
    ],
    userPhone: [
      {
        validator: (rule: any, value: any, callback: any) => {
          demandForm.value.userPhone =
            demandForm.value.userPhone &&
            demandForm.value.userPhone.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
          callback()
        },
        trigger: 'change',
      },
    ],
    oemCategory: [
      {
        trigger: 'blur',
        validator: (rule: any, value: any, callback: any) => {
          if (
            demandForm.value.oemCategory &&
            !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(demandForm.value.oemCategory)
          ) {
            callback('不允许输入任何符号、空格')
          }
          callback()
        },
      },
    ],
    refers: [
      {
        trigger: 'blur',
        validator: (rule: any, value: any, callback: any) => {
          if (
            demandForm.value.refers &&
            !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(demandForm.value.refers)
          ) {
            callback('不允许输入任何符号、空格')
          }
          callback()
        },
      },
    ],
    materialPurpose: [
      {
        trigger: 'blur',
        validator: (rule: any, value: any, callback: any) => {
          if (
            demandForm.value.materialPurpose &&
            !/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(demandForm.value.materialPurpose)
          ) {
            callback('不允许输入任何符号、空格')
          }
          callback()
        },
      },
    ],
  })

  // Enterprise Type Configuration
  const enterpriseTypeConfig = ref<Record<string, EnterpriseConfig>>({
    MATERIAL: {
      showFormItem: [
        '需求类型',
        '原料名称',
        '参考图片',
        '功效',
        '求购数量',
        '目标厂家',
        '详细描述',
        '企业名称',
        '联系人',
        '手机',
        '邮箱',
        '微信',
      ],
      title: '原料名称',
      titlePlaceholder: '请输入原料标准中文名称/INCI Name/原料商品名称/别名',
      demandQuantityPlaceholder: '请填写采购量（例：500kg）',
      refersPlaceholder: '请输入目标原料商',
      appearancePlaceholder: '请补充需求细节（如：需提供相应资质的原料供应商、交货周期 30 天内）',
      submitFormKey: [
        'purposeType',
        'title',
        'images',
        'materialPurpose',
        'demandQuantity',
        'refers',
        'content',
        'enterpriseName',
        'userName',
        'userPhone',
        'userEmail',
        'userWx',
      ],
    },
    OEM: {
      showFormItem: [
        '需求类型',
        '产品名称',
        '产品品类',
        '参考图片',
        '功效',
        '求购数量',
        '目标厂家',
        '详细描述',
        '企业名称',
        '联系人',
        '手机',
        '邮箱',
        '微信',
      ],
      title: '产品名称',
      titlePlaceholder: '请输入产品名称',
      demandQuantityPlaceholder: '请输入采购量（例：500支）',
      refersPlaceholder: '请输入目标厂家',
      appearancePlaceholder: '请补充需求细节（如：具备 GMP 认证的化妆品代工厂需提供质检报告、交货周期 30 天内）',
      submitFormKey: [
        'purposeType',
        'title',
        'oemCategory',
        'images',
        'efficacy',
        'demandQuantity',
        'refers',
        'content',
        'enterpriseName',
        'userName',
        'userPhone',
        'userEmail',
        'userWx',
      ],
    },
    END_PROD: {
      showFormItem: [
        '需求类型',
        '产品名称',
        '产品品类',
        '参考图片',
        '功效',
        '求购数量',
        '目标厂家',
        '详细描述',
        '企业名称',
        '联系人',
        '手机',
        '邮箱',
        '微信',
      ],
      title: '产品名称',
      titlePlaceholder: '请输入产品名称',
      demandQuantityPlaceholder: '请输入采购量（例：500支）',
      refersPlaceholder: '请输入目标厂家',
      appearancePlaceholder: '请补充需求细节（如：具备 GMP 认证的化妆品代工厂需提供质检报告、交货周期 30 天内）',
      submitFormKey: [
        'purposeType',
        'title',
        'oemCategory',
        'images',
        'efficacy',
        'demandQuantity',
        'refers',
        'content',
        'enterpriseName',
        'userName',
        'userPhone',
        'userEmail',
        'userWx',
      ],
    },
    PKG: {
      showFormItem: [
        '需求类型',
        '包材名称',
        '包材类型',
        '包材材质',
        '参考图片',
        '求购数量',
        '目标厂家',
        '详细描述',
        '企业名称',
        '联系人',
        '手机',
        '邮箱',
        '微信',
      ],
      title: '包材名称',
      titlePlaceholder: '请输入包材名称',
      demandQuantityPlaceholder: '请输入采购量（例：500个）',
      refersPlaceholder: '请输入目标厂家',
      appearancePlaceholder: '请补充需求细节（例：500g 装食品级 PET 塑料罐，要求密封防漏，印刷食品级油墨，需提供 QS 生产许可证明）',
      submitFormKey: [
        'purposeType',
        'title',
        'pkgCategory',
        'pkgMaterial',
        'images',
        'demandQuantity',
        'refers',
        'content',
        'enterpriseName',
        'userName',
        'userPhone',
        'userEmail',
        'userWx',
      ],
    },
    OTHER: {
      showFormItem: [
        '需求类型',
        '资源名称',
        '参考图片',
        '求购数量',
        '目标厂家',
        '详细描述',
        '企业名称',
        '联系人',
        '手机',
        '邮箱',
        '微信',
      ],
      title: '资源名称',
      titlePlaceholder: '请输入资源名称',
      demandQuantityPlaceholder: '请输入采购量',
      refersPlaceholder: '请输入目标厂家',
      appearancePlaceholder: '请补充资源细节（如：能提供护肤品类产品解决方案的产品开发厂家）',
      submitFormKey: [
        'purposeType',
        'title',
        'images',
        'demandQuantity',
        'refers',
        'content',
        'enterpriseName',
        'userName',
        'userPhone',
        'userEmail',
        'userWx',
      ],
    },
  })

  const currentEnterpriseConfig = computed<EnterpriseConfig>(() => {
    return enterpriseTypeConfig.value[demandForm.value.purposeType]
  })

  const handleSelect = (): void => {
    demandForm.value.title = ''
    DemandFormRef.value?.clearValidate()
  }

  const validForm = async (formRef: any): Promise<boolean> => {
    return new Promise((resolve) => {
      formRef.value.validate((valid: boolean) => {
        resolve(valid)
      })
    })
  }

  // Success Dialog
  const successDialogVisible = ref<boolean>(false)
  const handleCloseDialog = (): void => {
    successDialogVisible.value = false
    handleClose()
  }

  // 验证邮箱格式
  function validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }
  // Submit Demand
  const submitDemand = async (): Promise<void> => {
    const valid = await validForm(DemandFormRef)
    if (valid) {
      if (
        !demandForm.value.userPhone.trim() &&
        !demandForm.value.userEmail.trim() &&
        !demandForm.value.userWx.trim()
      ) {
        message.error('请至少填写1项联系方式！')
        return
      }

      // 如果填写了邮箱，验证邮箱格式
      if (demandForm.value.userEmail && !validateEmail(demandForm.value.userEmail)) {
        window.$message?.error('邮箱格式不正确，请重新输入！')
        return
      }
      let formParams: any = {}
      currentEnterpriseConfig.value.submitFormKey.forEach((item: string) => {
        formParams[item] = demandForm.value[item as keyof DemandForm]
      })

      formParams.images =
        formParams.images && formParams.images.length
          ? formParams.images.map((item: { imgUrl: string }) => item.imgUrl)
          : []
      try {
        await addDemand({...formParams, enterpriseId: workspaceId.value})
        successDialogVisible.value = true
        updateInfo({
          userName: formParams.userName,
          userPhone: formParams.userPhone,
          userEmail: formParams.userEmail,
          userWx: formParams.userWx,
        })
        emit('success')
      } catch (error) {
        window.$message?.error(error.resultMsg)
      }
    }
  }
</script>

<style lang="scss">
  .demand-drawer {
    &.el-drawer {
      width: 700px !important;
      .el-drawer__header {
        height: 56px;
        background: linear-gradient(270deg, #ff4080 0%, #ff7aa6 100%);
        padding: 0 20px;
        margin-bottom: 0;
        .el-drawer__title {
          color: #ffffff;
          font-size: 18px;
        }
        .el-drawer__close-btn {
          font-size: 24px;
          .el-icon {
            fill: #FFFFFF;
            color: #FFFFFF;
          }
        }
      }
      .el-drawer__body {
        padding: 0;
      }
    }

    .content-wrap {
      // margin-top: 30px;
      padding: 30px 20px 0 20px;
      height: calc(100vh - 109px);
      overflow-y: auto;
      .demand-form {
        input::-webkit-input-placeholder {
          font-weight: 400;
        }
        .el-form-item__label {
          padding-right: 50px;
        }
        .form-item-style-01 {
          width: 100%;
          .el-input__wrapper {
            border: none;
            background: #f8f8f8;
            box-shadow: none !important;
          }
          .el-input__inner {
            background: #f8f8f8;
            border: none;
            font-weight: 400;
          }
          .el-input__count-inner {
            background: #f8f8f8;
          }
          .el-textarea__inner {
            height: 80px;
            background: #f8f8f8;
            border: none;
            box-shadow: none;
            font-weight: 400;
          }
          .el-input__count {
            background: #f8f8f8;
            height: 28px;
          }
        }
        .phone-wrap {
          display: flex;
          .phone-type {
            width: 160px;
          }
          .phone-number {
            flex: 1;
            margin-left: 10px;
            .el-input__inner {
              background: #f8f8f8;
              border: none;
            }
            .el-input__count-inner {
              background: #f8f8f8;
            }
          }
        }
        .perfect-tips {
          padding: 10px 10px;
          background: #fff7f0;
          margin: 32px 0 20px 0;
          .el-alert__icon {
            top: 12px;
          }
          .el-alert__description {
            white-space: initial;
            margin: 0;
            font-size: 14px;
          }
        }

        .upload-wrap {
          .image-wrap {
            margin-right: 5px;
          }
          .upload-image {
            margin-right: 5px;
          }
        }
      }

      .my-info-wrap {
        position: relative;
        padding: 28px 0 28px 8px;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        line-height: 17px;

        &::after {
          content: '';
          position: absolute;
          top: 0px;
          left: -20px;
          width: calc(100% + 40px);
          height: 1px;
          background: rgba(0,0,0,0.1);
        }

        .my-info-tip {
          color: #8FA1B2;
        }
      }

      .tips {
        display: flex;
        .tips-label {
          width: 136px;
          padding-right: 50px;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          text-align: right;
          box-sizing: border-box;
        }
        .tips-content {
          font-size: 12px;
          color: #8FA1B2;
          line-height: 24px;
        }
      }

      // .specified-form {
      //   .form-item-style-01 {
      //     width: 100%;
      //     .el-input__inner {
      //       background: #f8f8f8;
      //       border: none;
      //     }
      //     .el-input__count-inner {
      //       background: #f8f8f8;
      //     }
      //     .el-textarea__inner {
      //       height: 80px;
      //       background: #f8f8f8;
      //       border: none;
      //     }
      //     .el-input__count {
      //       background: #f8f8f8;
      //       height: 30px;
      //     }
      //   }
      //   .phone-wrap {
      //     display: flex;
      //     .phone-type {
      //       width: 160px;
      //     }
      //     .phone-number {
      //       flex: 1;
      //       margin-left: 10px;
      //       .el-input__inner {
      //         background: #f8f8f8;
      //         border: none;
      //       }
      //       .el-input__count-inner {
      //         background: #f8f8f8;
      //       }
      //     }
      //   }
      // }
    }

    .footer {
      position: absolute;
      bottom: 10px;
      text-align: right;
      width: 100%;
      left: 0;
      // border-top: 1px solid rgba(0, 0, 0, 0.1);
      padding-top: 10px;
      .cancle-btn {
        padding: 9px 28px;

        &:hover, &:focus {
          color: #ff4080;
          border-color: #ffc6d9;
          background-color: #ffecf2;
        }
      }
      .confirm-btn {
        padding: 9px 28px;
        margin-right: 24px;
        color: #FFFFFF;
        background-color: #ff4080;
        border-color: #ff4080;

        &:hover, &:focus {
          background: #ff6699;
          border-color: #ff6699;
          color: #FFFFFF;
        }
      }
    }
  }

  .demand-success-dialog {
    &.el-dialog {
      border-radius: 4px;
    }
    .el-dialog__header {
      background: linear-gradient(90deg, #FF67D5 0%, #A28BFF 100%);
      border-radius: 4px 4px 0 0;
      padding: 16px 14px 15px 24px;
      padding-bottom: 15px;
      margin-right: 0;

      .el-dialog__title {
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 25px;
      }

      .el-dialog__headerbtn {
        top: 16px;
        right: 14px;
        width: 24px;
        height: 24px;
        .el-dialog__close {
          color: #FFFFFF;
          font-size: 24px;
        }
      }

    }

    .el-dialog__body {
      padding: 40px 50px 28px;
    }

    .success-dialog-content {
      .success-wrap {
        width: fit-content;
        display: flex;
        align-items: center;
        padding: 17px 19px 17px 24px;
        margin-bottom: 24px;
        background: #F3FFF6;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #92F164;
        font-weight: 400;
        font-size: 16px;
        color: #333333;

        .icon-success {
          margin-right: 16px;
          width: 20px;
          height: 20px;
          background: url('./images/icon-success.png') no-repeat center center;
          background-size: 100% 100%;
        }
      }

      .success-tips {
        display: flex;

        .tips-label {
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 22px;
        }

        .tips-content {
          flex: 1;
          font-size: 14px;
          color: #666666;
          line-height: 22px;

          .tips-text {
            color: #333333;
          }
        }
      }

      .footer-wrap {
        display: flex;
        justify-content: flex-end;
        margin-top: 28px;

        .footer-btn {
          width: 163px;
          height: 36px;
          padding: 8px 60px;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }
  }
</style>
